import React from "react";
import { toElementProps } from "../../Element";

export function EmbedStyles(params = {}) {
    const TabletBreakpoint = "@media (max-width:1199.95px)";

    return {
        "& .embed": {
            display: "grid",
            width: "1200px",
            margin: "0 auto",

            [TabletBreakpoint]: {
                width: "100%",
            },
        },
    };
}

export default function Embed(props) {
    const { iframe } = props;

    const elProps = toElementProps(props, { className: ["embed"] });

    return (
        <div className="embed" {...elProps}>
            {iframe && <div dangerouslySetInnerHTML={{ __html: iframe }} />}
        </div>
    );
}
